import { render, staticRenderFns } from "./RegistrationTile.vue?vue&type=template&id=eb738f3c&scoped=true&"
import script from "./RegistrationTile.vue?vue&type=script&lang=js&"
export * from "./RegistrationTile.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationTile.vue?vue&type=style&index=0&id=eb738f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb738f3c",
  null
  
)

export default component.exports